import ModalTip from './ModalTip.vue'
ModalTip.install = function (Vue) {
  Vue.component(ModalTip.name, ModalTip)
}
export default ModalTip



// WEBPACK FOOTER //
// ./src/pages/common/components/modaltip/index.js